import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";

export {
    GetAllValidationRules,
    SaveValidationRule
};

function GetAllValidationRules(onSuccess, onError) {
    var headers = getAuthHeader();

    axios
        .get(process.env.VUE_APP_BASE_API_URL + "/customcontractValidation", headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function SaveValidationRule(validationRuleId, validationRule, onSuccess, onError) {
    var headers = getAuthHeader();

    axios
        .put(process.env.VUE_APP_BASE_API_URL + `/customcontractValidation/${validationRuleId}`, validationRule, headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}